
define('text!gameInterfaces/pages/MicrogamingGameInterface.html',[],function () { return '<div data-bind="compose: { model: realityCheckViewModel, view: \'features/realityCheck/realityCheck.html\' }">\n</div>\n';});

